import React, { useEffect, useState } from "react";
import { Container, Col, FormGroup, Label } from "reactstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loading } from "../../../share/loading";
import "../../../share/form.css";
import "../../../borrowSystem/Admin.css";
import "../../../borrowSystem/BorrowForm/TabBorrowComponent.css";
import { NumberWithCommmas2 } from "../../../share/NumberWithCommmas2";

export function ApproveInnovationAnnouce10DetailComponent() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [toggleState, setToggleState] = useState(1);
  const [loading, setLoading] = useState(false);
  // const [data, setData] = useState([]);
  // const [supportDetails, setSupportDetails] = useState([]);
  const [datasupportDetails, setsupportDetailsData] = useState([]);
  const [innovationCourseData, setinnovationCourseData] = useState([]);
  const [expenseInnovationData, setExpenseInnovationData] = useState([]);

  const [openCourses, setOpenCourses] = useState([]);
  const [openCourses2, setOpenCourses2] = useState([]);
  // const [openCourses3, setOpenCourses3] = useState([]);

  const [showTrainData, setShowTrainData] = useState(false);
  const [showTrainData2, setShowTrainData2] = useState(false);

  // const user = JSON.parse(localStorage.getItem("userData"));

  useEffect(() => {
    getdetailsupport();
  }, []);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const toggleShowTrainData = () => {
    setShowTrainData(!showTrainData);
  };
  const toggleShowTrainData2 = () => {
    setShowTrainData2(!showTrainData2);
  };

  function opencourse(id) {
    if (openCourses.includes(id)) {
      setOpenCourses(openCourses.filter((i) => i !== id));
    } else {
      setOpenCourses([...openCourses, id]);
    }
  }
  function opencourse2(id) {
    if (openCourses2.includes(id)) {
      setOpenCourses2(openCourses2.filter((i) => i !== id));
    } else {
      setOpenCourses2([...openCourses2, id]);
    }
  }

  async function getdetailsupport() {
    setLoading(true);
    let postData = new FormData();
    // postData.append("deptId", user.deptId)
    postData.append("SupportInnovationId", searchParams.get("req"));
    try {
      let res = await fetch("/api/Support/getInnovatinodata", {
        method: "POST",
        body: postData,
      });
      // let resJson = await res.json();
      // await resJson.dataenum.map((item) =>{
      //   const { supportcompanyAddress , supportlawocDetails ,
      //     supportcurrentAddress,
      //     supportCoordinates,supportDetails } = item;

      // });
      const data = await res.json();
      // console.log(data.dataenum);
      // setData(data.dataenum);
      setsupportDetailsData(data.dataenum.supportInnovationData);
      setinnovationCourseData(data.dataenum.innovationCourseData);
      setExpenseInnovationData(data.dataenum.expenseInnovationData);

      // console.log("dataalldetail", data.dataenum);
    } catch (e) {
      // console.log("err =>" + e);
    } finally {
      setLoading(false);
    }
  }

  // const currentYear = new Date().getFullYear() + 543;

  return (
    <>
      <Container className="d-flex justify-content-center align-items-center mt-2 mb-4 tab-container">
        <div
          className={
            toggleState === 1
              ? "tab-item tab-item-active text-center"
              : "tab-item tab-item-non-active text-center"
          }
          // className="tab-item tab-item-active text-center"
          style={{ lineHeight: "3rem", cursor: "pointer" }}
          onClick={() => {
            toggleTab(1);
          }}
        >
          <span className="px-3">รายละเอียดเกี่ยวกับผู้ขอรับอุดหนุน</span>
        </div>

        <div
          className={
            toggleState === 2
              ? "tab-item tab-item-active text-center"
              : "tab-item tab-item-non-active text-center"
          }
          // className="tab-item tab-item-active text-center"
          style={{ lineHeight: "3rem", cursor: "pointer" }}
          onClick={() => {
            toggleTab(2);
          }}
        >
          <span className="px-3">รายละเอียดเกี่ยวกับการฝึกอบรม</span>
        </div>
        <div
          className={
            toggleState === 3
              ? "tab-item tab-item-active text-center"
              : "tab-item tab-item-non-active text-center"
          }
          // className="tab-item tab-item-active text-center"
          style={{ lineHeight: "3rem", cursor: "pointer" }}
          onClick={() => {
            toggleTab(3);
          }}
        >
          <span className="px-3">ค่าใช้จ่ายในการฝึกอบรม</span>
        </div>
      </Container>

      <Container className="d-flex flex-column justify-content-center align-items-center">
        <div className="form-border">
          {!loading ? (
            <>
              <div className={toggleState === 1 ? "p-5 mb-4" : "non-active"}>
                <div>
                  <FormGroup>
                    <Label className="">
                      ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน :
                    </Label>
                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                      {datasupportDetails?.supportName
                        ? datasupportDetails?.supportName
                        : "-"}
                    </p>
                  </FormGroup>
                  <FormGroup>
                    <Label className="">เลขที่ทะเบียนนิติบุคคล</Label>
                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                      {datasupportDetails?.customerNo
                        ? datasupportDetails?.customerNo
                        : "-"}
                    </p>
                  </FormGroup>
                  <FormGroup>
                    <Label className="">ผู้มีอำนาจแทนหรือผู้รับมอบอำนาจ</Label>
                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                      {/* {supportDetails.supportName
                        ? supportDetails.supportName
                        : "-"} */}{" "}
                      -
                    </p>
                  </FormGroup>
                  <FormGroup>
                    <Label className="">เลขประจำตัวประชาชน</Label>
                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                      {datasupportDetails?.personalNo
                        ? datasupportDetails?.personalNo
                        : "-"}
                    </p>
                  </FormGroup>

                  <Label className="mt-1">ที่อยู่</Label>
                  <FormGroup row className="m-3">
                    <Label for="addNo" sm={2}>
                      เลขที่
                    </Label>
                    <Col sm={4}>
                      <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                        {datasupportDetails?.addressNo
                          ? datasupportDetails?.addressNo
                          : "-"}
                      </p>
                    </Col>

                    <Label for="moo" sm={2}>
                      หมู่ที่
                    </Label>
                    <Col sm={4}>
                      <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                        {datasupportDetails?.moo
                          ? datasupportDetails?.moo
                          : "-"}
                      </p>
                    </Col>
                  </FormGroup>

                  <FormGroup row className="m-3">
                    <Label for="soi" sm={2}>
                      ซอย
                    </Label>
                    <Col sm={4}>
                      <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                        {datasupportDetails?.soi
                          ? datasupportDetails?.soi
                          : "-"}
                      </p>
                    </Col>

                    <Label for="street" sm={2}>
                      ถนน
                    </Label>
                    <Col sm={4}>
                      <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                        {datasupportDetails?.street
                          ? datasupportDetails?.street
                          : "-"}
                      </p>
                    </Col>
                  </FormGroup>

                  <FormGroup row className="m-3">
                    <Label for="province" sm={2}>
                      จังหวัด
                    </Label>
                    <Col sm={4}>
                      <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                        {datasupportDetails?.provinc
                          ? datasupportDetails?.provinc
                          : "-"}
                      </p>
                    </Col>

                    <Label for="amphur" sm={2}>
                      อำเภอ/เขต
                    </Label>
                    <Col sm={4}>
                      <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                        {datasupportDetails?.amphur
                          ? datasupportDetails?.amphur
                          : "-"}
                      </p>
                    </Col>
                  </FormGroup>

                  <FormGroup row className="m-3">
                    <Label for="tumbon" sm={2}>
                      ตำบล/แขวง
                    </Label>
                    <Col sm={4}>
                      <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                        {datasupportDetails?.tumbon
                          ? datasupportDetails?.tumbon
                          : "-"}
                      </p>
                    </Col>

                    <Label for="amphur" sm={2}>
                      รหัสไปรษณีย์
                    </Label>
                    <Col sm={4}>
                      <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                        {datasupportDetails?.postCode
                          ? datasupportDetails?.postCode
                          : "-"}
                      </p>
                    </Col>
                  </FormGroup>
                </div>
              </div>

              <div className={toggleState === 2 ? "p-5 mb-4" : "non-active"}>
                {innovationCourseData.length ? (
                  <>
                    <div>
                      <p
                        className="w-100 text-white text-center rounded-pill "
                        style={{
                          backgroundColor: "#0A66C2",
                          lineHeight: "3rem",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          toggleShowTrainData();
                        }}
                      >
                        การขอรับอุดหนุนเพื่อดำเนินการทดสอบ
                      </p>

                      {innovationCourseData.map((trainItem, index) => (
                        <div
                          key={index}
                          className={showTrainData !== true ? "non-active" : ""}
                        >
                          <p
                            className="customer-type w-50  text-center border border-primary rounded-pill"
                            style={{
                              lineHeight: "2.5rem",
                              cursor: "pointer",
                            }}
                            onClick={() => opencourse(index)}
                          >
                            {trainItem.innovationCourseName
                              ? trainItem.innovationCourseName
                              : trainItem?.innovationName}
                          </p>
                          <div
                            className={
                              !openCourses.includes(index) ? "non-active" : ""
                            }
                          >
                            <FormGroup>
                              <Label className="">
                                ชื่อหลักสูตรฝึกอบรมเพื่อสร้างสรรค์นวัตกรรม
                              </Label>
                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                              {trainItem.innovationCourseName
                              ? trainItem.innovationCourseName
                              : trainItem?.innovationName}
                              </p>
                            </FormGroup>
                            <Label className="">
                              รายละเอียดเกี่ยวกับการฝึกอบรม
                            </Label>
                            <FormGroup>
                              <Label className="">ชื่อหลักสูตร</Label>
                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                {trainItem?.innovationCourseName
                                  ? trainItem?.innovationCourseName
                                  : "-"}
                              </p>
                              <Label className="">รุ่นที่</Label>
                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                {trainItem?.class ? trainItem?.class : "-"}
                              </p>
                              <Label className="">ผู้เข้ารับการฝึกอบรม</Label>
                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                {trainItem?.personTotal
                                  ? trainItem?.personTotal
                                  : "-"}
                              </p>
                              <Label className="">ระยะเวลาในการฝึกอบรม</Label>
                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                {trainItem?.hour ? trainItem?.hour : "-"}
                              </p>
                            </FormGroup>

                            <FormGroup row className="m-3">
                              <Label for="tumbon" sm={2}>
                                วันที่
                              </Label>
                              <Col sm={4}>
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                  {trainItem?.startDate
                                    ? trainItem?.startDate
                                    : "-"}
                                </p>
                              </Col>

                              <Label for="amphur" sm={2}>
                                ถึงวันที่
                              </Label>
                              <Col sm={4}>
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                  {trainItem?.endDate
                                    ? trainItem?.endDate
                                    : "-"}
                                </p>
                              </Col>
                            </FormGroup>

                            <FormGroup>
                              <Label className="">จำนวนคน</Label>
                              <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                {trainItem.personTotal
                                  ? trainItem.personTotal
                                  : "-"}
                              </p>
                            </FormGroup>

                            <Label className="">ชื่อสถานที่ฝึกอบรม</Label>
                            <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                              {trainItem.locationName
                                ? trainItem.locationName
                                : "-"}
                            </p>

                            <FormGroup row className="m-3">
                              <Label for="addNo" sm={2}>
                                เลขที่
                              </Label>
                              <Col sm={4}>
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                  {trainItem.addressNo
                                    ? trainItem.addressNo
                                    : "-"}
                                </p>
                              </Col>

                              <Label for="moo" sm={2}>
                                หมู่ที่
                              </Label>
                              <Col sm={4}>
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                  {trainItem.moo ? trainItem.moo : "-"}
                                </p>
                              </Col>
                            </FormGroup>

                            <FormGroup row className="m-3">
                              <Label for="soi" sm={2}>
                                ซอย
                              </Label>
                              <Col sm={4}>
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                  {trainItem.soi ? trainItem.soi : "-"}
                                </p>
                              </Col>

                              <Label for="street" sm={2}>
                                ถนน
                              </Label>
                              <Col sm={4}>
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                  {trainItem.street ? trainItem.street : "-"}
                                </p>
                              </Col>
                            </FormGroup>

                            <FormGroup row className="m-3">
                              <Label for="province" sm={2}>
                                จังหวัด
                              </Label>
                              <Col sm={4}>
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                  {trainItem.provinc ? trainItem.provinc : "-"}
                                </p>
                              </Col>

                              <Label for="amphur" sm={2}>
                                อำเภอ/เขต
                              </Label>
                              <Col sm={4}>
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                  {trainItem.amphur ? trainItem.amphur : "-"}
                                </p>
                              </Col>
                            </FormGroup>

                            <FormGroup row className="m-3">
                              <Label for="tumbon" sm={2}>
                                ตำบล/แขวง
                              </Label>
                              <Col sm={4}>
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                  {trainItem.tumbon ? trainItem.tumbon : "-"}
                                </p>
                              </Col>

                              <Label for="amphur" sm={2}>
                                รหัสไปรษณีย์
                              </Label>
                              <Col sm={4}>
                                <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                                  {trainItem.postcode
                                    ? trainItem.postcode
                                    : "-"}
                                </p>
                              </Col>
                            </FormGroup>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                ) : null}
              </div>

              <div className={toggleState === 3 ? "p-5 mb-4" : "non-active"}>
                {expenseInnovationData.length ? (
                  <>
                    <div>
                      <p
                        className="w-100 text-white text-center rounded-pill "
                        style={{
                          backgroundColor: "#0A66C2",
                          lineHeight: "3rem",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          toggleShowTrainData2();
                        }}
                      >
                        การขอรับอุดหนุนเพื่อดำเนินการทดสอบ
                      </p>
                      {expenseInnovationData.map((trainItem, index) => (
                        <div key={index} className={showTrainData2 !== true ? "non-active" : ""}>
                          <p
                            className="customer-type w-50  text-center border border-primary rounded-pill"
                            style={{
                              lineHeight: "2.5rem",
                              cursor: "pointer",
                            }}
                            onClick={() => opencourse2(index)}
                          >
                            
                              {innovationCourseData[0]?.innovationCourseName
                              ? innovationCourseData[0]?.innovationCourseName
                              : innovationCourseData[0]?.innovationName}
                          </p>
                          <div
                            className={
                              !openCourses2.includes(index) ? "non-active" : ""
                            }
                          >
                            {trainItem.inoutTypeId == "1" ? (
                              <>
                                <Label className="">
                                  ดำเนินการฝึกเอง (Inhouse Training)
                                </Label>
                                <FormGroup className="mt-3">
                                  <Label className="">ค่าตอบแทนวิทยากร</Label>
                                </FormGroup>
                                <FormGroup className="mt-3">
                                  <Label className="mt-3">จำนวนชั่วโมง</Label>
                                  <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                    {trainItem.tutorHourAmount ? trainItem.tutorHourAmount : "-"} ชั่วโมง

                                  </p>
                                  <Label className="">ชั่วโมงละ</Label>
                                  <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                    {NumberWithCommmas2(trainItem.tutorRate) ? NumberWithCommmas2(trainItem.tutorRate) : "-"} บาท

                                  </p>
                                  <Label className="">จำนวนเงิน</Label>
                                  <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                    {NumberWithCommmas2((trainItem.tutorHourAmount) * (trainItem.tutorRate)) ? NumberWithCommmas2((trainItem.tutorHourAmount) * (trainItem.tutorRate)) : "-"} บาท
                                  </p>
                                </FormGroup>

                                <Label className="mt-3">ค่าวัสดุต่างๆ</Label>
                                <FormGroup className="mt-3">
                                  <Label className="">จำนวนเงิน</Label>
                                  <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                    {NumberWithCommmas2(trainItem.materialAmount) ? NumberWithCommmas2(trainItem.materialPersonAmount) : "-"} บาท
                                  </p>

                                  <Label className="">เฉลี่ยต่อคนเป็นเงิน</Label>
                                  <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                    {NumberWithCommmas2(trainItem.materialPersonAmount) ? NumberWithCommmas2(trainItem.materialPersonAmount) : "-"} บาท
                                  </p>
                                </FormGroup>
                                <Label className="mt-3">รวมค่าใช้จ่ายในการฝึกอบรม</Label>
                                <FormGroup className="mt-3">
                                  <Label className="">จำนวนเงิน</Label>
                                  <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                    {NumberWithCommmas2((trainItem.tutorHourAmount) + (trainItem.materialAmount)) ? NumberWithCommmas2((trainItem.tutorHourAmount) + (trainItem.materialAmount)) : "-"} บาท
                                  </p>
                                  <Label className="">เฉลี่ยต่อคนเป็นเงิน</Label>
                                  <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                    {NumberWithCommmas2(((trainItem.tutorHourAmount) + (trainItem.materialAmount)) / (trainItem.personTotal)) ? NumberWithCommmas2(((trainItem.tutorHourAmount) + (trainItem.materialAmount)) / (trainItem.personTotal)) : "-"} บาท

                                  </p>
                                </FormGroup>
                              </>
                            ) : null}

                            {trainItem.inoutTypeId == "2" ? (
                              <>
                                <Label className="">
                                  ส่งไปฝึกอบรมภายนอก (Public Training)
                                </Label>
                                <FormGroup className="mt-3">
                                  <Label className="">ค่าตอบแทนวิทยากร</Label>
                                </FormGroup>
                                <FormGroup className="mt-3">
                                  <Label className="mt-3">จำนวนชั่วโมง</Label>
                                  <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                    {trainItem.tutorHourAmount ? trainItem.tutorHourAmount : "-"} ชั่วโมง

                                  </p>
                                  <Label className="">ชั่วโมงละ</Label>
                                  <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                    {NumberWithCommmas2(trainItem.tutorRate) ? NumberWithCommmas2(trainItem.tutorRate) : "-"} บาท

                                  </p>
                                  <Label className="">จำนวนเงิน</Label>
                                  <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                    {NumberWithCommmas2((trainItem.tutorHourAmount) * (trainItem.tutorRate)) ? NumberWithCommmas2((trainItem.tutorHourAmount) * (trainItem.tutorRate)) : "-"} บาท
                                  </p>
                                </FormGroup>

                                <Label className="mt-3">ค่าวัสดุต่างๆ</Label>
                                <FormGroup className="mt-3">
                                  <Label className="">จำนวนเงิน</Label>
                                  <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                    {NumberWithCommmas2(trainItem.materialAmount) ? NumberWithCommmas2(trainItem.materialPersonAmount) : "-"} บาท
                                  </p>

                                  <Label className="">เฉลี่ยต่อคนเป็นเงิน</Label>
                                  <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                    {NumberWithCommmas2(trainItem.materialPersonAmount) ? NumberWithCommmas2(trainItem.materialPersonAmount) : "-"} บาท
                                  </p>
                                </FormGroup>
                                <Label className="mt-3">รวมค่าใช้จ่ายในการฝึกอบรม</Label>
                                <FormGroup className="mt-3">
                                  <Label className="">จำนวนเงิน</Label>
                                  <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                    {NumberWithCommmas2((trainItem.tutorHourAmount) + (trainItem.materialAmount)) ? NumberWithCommmas2((trainItem.tutorHourAmount) + (trainItem.materialAmount)) : "-"} บาท
                                  </p>
                                  <Label className="">เฉลี่ยต่อคนเป็นเงิน</Label>
                                  <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                    {NumberWithCommmas2(((trainItem.tutorHourAmount) + (trainItem.materialAmount)) / (trainItem.personTotal)) ? NumberWithCommmas2(((trainItem.tutorHourAmount) + (trainItem.materialAmount)) / (trainItem.personTotal)) : "-"} บาท

                                  </p>
                                </FormGroup>
                              </>
                            ) : null}

                            {trainItem.inoutTypeId == "3" ? (
                              <>
                                <Label className="">
                                  ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน
                                </Label>
                                <FormGroup className="mt-3">
                                  <Label className="">จำนวนคน</Label>
                                  <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                    {trainItem.personAmount ? trainItem.personAmount : "-"} คน
                                  </p>
                                  <Label className="">จำนวนเงิน</Label>
                                  <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                    {NumberWithCommmas2(trainItem.amount) ? NumberWithCommmas2(trainItem.amount) : "-"} บาท
                                  </p>

                                </FormGroup>
                                <Label className="mt-3">รวมค่าใช้จ่ายในการทดสอบ</Label>
                                <FormGroup className="mt-3">
                                  <Label className="">จำนวนเงิน</Label>
                                  <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                    {NumberWithCommmas2((trainItem.amount)) ? NumberWithCommmas2((trainItem.personAmount)) : "-"} บาท
                                  </p>
                                  <Label className="">เฉลี่ยต่อคนเป็นเงิน</Label>
                                  <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                    {NumberWithCommmas2((trainItem.amount) / (trainItem.personAmount)) ? NumberWithCommmas2((trainItem.amount) / (trainItem.personAmount)) : "-"} บาท

                                  </p>
                                </FormGroup>
                              </>
                            ) : null}

                            {trainItem.inoutTypeId == "4" ? (
                              <>
                                <Label className="">
                                  ส่งลูกจ้างเข้ารับการทดสอบมาตรฐานฝีมือแรงงาน
                                </Label>
                                <FormGroup className="mt-3">
                                  <Label className="">จำนวนคน</Label>
                                  <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                    {trainItem.personAmount ? trainItem.personAmount : "-"} คน
                                  </p>
                                  <Label className="">จำนวนเงิน</Label>
                                  <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                    {NumberWithCommmas2(trainItem.amount) ? NumberWithCommmas2(trainItem.amount) : "-"} บาท
                                  </p>

                                </FormGroup>
                                <Label className="mt-3">รวมค่าใช้จ่ายในการทดสอบ</Label>
                                <FormGroup className="mt-3">
                                  <Label className="">จำนวนเงิน</Label>
                                  <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                    {NumberWithCommmas2((trainItem.amount)) ? NumberWithCommmas2((trainItem.personAmount)) : "-"} บาท
                                  </p>
                                  <Label className="">เฉลี่ยต่อคนเป็นเงิน</Label>
                                  <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                    {NumberWithCommmas2((trainItem.amount) / (trainItem.personAmount)) ? NumberWithCommmas2((trainItem.amount) / (trainItem.personAmount)) : "-"} บาท

                                  </p>
                                </FormGroup>
                              </>
                            ) : null}
                          </div>

                          <Label className="mt-3">
                            รวมค่าใช้จ่ายในการฝึกอบรมทั้งหมด
                          </Label>
                          <FormGroup className="mt-3">
                            <Label className="">จำนวนเงิน</Label>
                            <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                            {NumberWithCommmas2((trainItem.tutorHourAmount) + (trainItem.materialAmount)) ? NumberWithCommmas2((trainItem.tutorHourAmount) + (trainItem.materialAmount)) : "-"} บาท
                              
                            </p>
                            <Label className="">เฉลี่ยต่อคนเป็นเงิน</Label>
                            <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                            {NumberWithCommmas2(((trainItem.tutorHourAmount) + (trainItem.materialAmount)) / (trainItem.personTotal)) ? NumberWithCommmas2(((trainItem.tutorHourAmount) + (trainItem.materialAmount)) / (trainItem.personTotal)) : "-"} บาท
                            
                            </p>
                          </FormGroup>

                        </div>
                      ))}




                    </div>

                  </>
                ) : null}
              </div>

              <div className="d-flex align-items-center justify-content-center w-100 mb-2">
                <button
                  onClick={() => {
                    navigate(
                      `/supporting/support/ApproveInnovationAnnouce10?req=${searchParams.get(
                        "req"
                      )}`
                    );
                  }}
                  className="btn-blue p-2 w-50"
                >
                  ย้อนกลับ
                </button>
              </div>
            </>
          ) : (
            <Loading />
          )}
        </div>
      </Container>
    </>
  );
}
